import React from 'react';
import styles from './TipMatchForecastInfo.module.scss';
import SVG from 'react-inlinesvg';

/* Interfaces */
import { UnlockedMatchForecast } from '../../../../../../store/tips/reducer';
import { TipProduct } from '../../../interfaces/TipProduct';

/* Providers */
import { useShopContext } from '../../../../shared/__providers__/ShopContext';

/* Utils */
import { getSportIcon } from '../../../../../TipPublish/utils/icons/getSportIcon';

/* Components */
import { TipResultDot } from '../ResultDot/TipResultDot';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../../../utils/translations/translator';

interface TipMatchForecastInfoProps {
  forecast: UnlockedMatchForecast;
}

export const TipMatchForecastInfo: React.FC<TipMatchForecastInfoProps> = ({
  forecast,
}) => {
  const { shop } = useShopContext();
  const { t } = useTranslation();
  const tip = shop!.selectedProduct as TipProduct;

  return (
    <>
      {tip && (
        <div key={forecast.id} className={styles.match}>
          <div className={styles.topRow}>
            <span className={styles.text}>
              {tip.matchesByID[forecast.match_id].home_player}
              {tip.matchesByID[forecast.match_id].away_player.length
                ? ` - ${tip.matchesByID[forecast.match_id].away_player}`
                : ''}
            </span>

            <span className={styles.date}>
              {tip.startedAt.format('DD Month HH:mm')}
            </span>
          </div>

          <div className={styles.sportsContainer}>
            <SVG
              src={getSportIcon(tip.matchesByID[forecast.match_id].sport_code)}
            />

            {tr(t, tip.matchesByID[forecast.match_id].sport)}

            {' - '}

            {tip.matchesByID[forecast.match_id].competition_name}
          </div>

          <div className={styles.pickInfo}>
            <div className={styles.line} />

            <div className={styles.pickMsgAndResult}>
              <TipResultDot result={forecast.result} />

              <div className={styles.pickAndMarket}>
                <div className={styles.pick}>
                  <span className={styles.msg}>{forecast.pick}</span>

                  <span className={styles.pickIcon}>
                    {tr(t, 'tip').toUpperCase()}
                  </span>
                </div>

                <span className={styles.market}>
                  {t(`markets:bet_markets_${forecast.market}`).replace(
                    'bet_markets_',
                    '',
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
